import React, { PropsWithChildren, useState } from "react";
import { useForm } from "react-hook-form";

import { GetFileRecordDetailsResponse } from "../../../../../../common/api/master-api/file-records/details/GetFileRecordDetailsResponse";
import { RecordType } from "../../../../../../common/types/RecordType";
import { StorageType } from "../../../../../../common/types/StorageType";
import { CreateFileRecordFormInputs, defaultFormInputs } from "../../CreateFileRecordFormInputs";
import { CreateFileRecordStateContext } from "./CreateFileRecordStateContext";

type CreateFileRecordProviderProps = PropsWithChildren<unknown>;

export const CreateFileRecordStateProvider: React.FC<CreateFileRecordProviderProps> = (
    props: CreateFileRecordProviderProps
) => {
    const [sourceFileRecord, setSourceFileRecord] = useState<GetFileRecordDetailsResponse>();
    const [selectedRecordType, setSelectedRecordType] = useState<RecordType>();
    const [selectedStorageType, setSelectedStorageType] = useState<StorageType>();

    const form = useForm<CreateFileRecordFormInputs>({
        criteriaMode: "firstError",
        shouldUnregister: false,
        defaultValues: defaultFormInputs
    });

    const [isLoading, setIsLoading] = useState<boolean>(false);

    return (
        <CreateFileRecordStateContext.Provider
            value={{
                selectedRecordType,
                setSelectedRecordType,
                selectedStorageType,
                setSelectedStorageType,
                sourceFileRecord,
                setSourceFileRecord,
                isLoading,
                setIsLoading,
                form
            }}
        >
            {props.children}
        </CreateFileRecordStateContext.Provider>
    );
};
